import { Api } from 'lib';

/**
 * Updates the profile view count for a given user if the user is viewing their own profile.
 *
 * @async
 * @function updateViewCount
 * @param {Object} params - Parameters for updating the view count.
 * @param {Object} params.payload - The payload to send to the API.
 * @param {string} params.payload.userId - The ID of the user whose profile is being viewed.
 * @param {string} params.payload.trigger - The type of trigger (e.g., "photo", "comment", etc.).
 * @param {string} params.currentUserId - The ID of the current logged-in user.
 * @returns {Promise<Object|undefined>} The API response if successful; otherwise, `undefined` if the condition is not met.
 * @throws Will throw an error if the API request fails.
 */
const updateViewsCount = async ({ payload, currentUserId }) => {
  if (!payload.userId === currentUserId) return;

  try {
    const res = await Api.put('/views/updateViewCount', payload);
    return res;
  } catch (err) {
    throw err;
  }
};

export default updateViewsCount;
